<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="handleClose"
    width="1240px"
  >
    <div class="df aic" style="height: 30px; justify-content: flex-end" v-if="showToggleButton">
      <el-button
        v-if="isRealTime"
        type="text"
        class="disib blue"
        size="mini"
        @click="handleReplyPics"
        >留影回看</el-button
      >
      <el-button
        v-else
        type="text"
        class="disib blue"
        size="mini"
        @click="handleViewLive"
        >查看直播</el-button
      >
    </div>
    <div v-if="isRealTime">
      <live-video
        height="690"
        :autoplay="false"
        :id="videoUrl"
        :key="videoUrl"
        :companyId="companyId"
        :camId="camId"
        :ref="'live-video-' + camId"
        v-if="visible && isRealTime"
      ></live-video>
    </div>
    <div v-else>
      <!-- 新增图片记录列表部分 -->
      <div class="df" style="height: 690px">
        <div style="flex: 0 0 800px; width: 0px">
          <div v-if="!checkedHisListId">
            <el-date-picker
              v-model="timeValue"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 100%"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              @change="handleTimeChange"
            >
            </el-date-picker>
          </div>
          <div v-else style="margin-bottom: 10px">
            <el-button
              size="mini"
              @click="handleReturnToList"
              icon="el-icon-arrow-left"
              >返回列表</el-button
            >
          </div>
          
          <!-- 图片显示区域 -->
          <div style="margin-top: 10px" v-loading="picLoading">
            <!-- 未抓取到图片时的提示 -->
            <div v-if="showNoImageMessage" class="image-slot no-image-message">
              <i class="el-icon-picture-outline"></i>
              <div>未抓取到摄像图片</div>
            </div>
            
            <!-- 正常图片显示 -->
            <el-image
              v-else
              :src="imageSrc"
              :preview-src-list="checkedHisListId ? hisListDetail.map(item => item.imgUrl) : [imageSrc]"
              style="width: 100%; max-height: 400px; object-fit: contain; background-color: #f5f7fa;"
              @load="handleImageLoad"
              @error="handleImageError"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
                <div>图片加载失败</div>
              </div>
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          
          <!-- AI结果显示区域 -->
          <div v-if="showAiResult" class="ai-result-container" style="margin-top: 15px;">
            <div class="ai-result-header">
              <span style="font-weight: bold; color: #409eff;">AI识别结果</span>
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">
                {{ currentAiResultTime }}
              </span>
            </div>
            <div class="ai-result-content" v-html="formatAiResult(currentAiResult)"></div>
          </div>

          <el-row
            type="flex"
            class="row-bg"
            justify="space-around"
            style="margin-top: 10px"
          >
            <el-col :span="6" style="text-align: center">
              <el-button size="mini" @click="handlePre" :disabled="isFirstImage || showNoImageMessage">上一张</el-button>
            </el-col>
            <el-col :span="6" style="text-align: center; line-height: 2;" v-if="checkedHisListId && !showNoImageMessage">
              {{ currentImageIndex + 1 }} / {{ hisListDetail.length }}
            </el-col>
            <el-col :span="6" style="text-align: center">
              <el-button size="mini" @click="handleNext" :disabled="isLastImage || showNoImageMessage">下一张</el-button>
            </el-col>
          </el-row>
        </div>

        <!-- 图片记录列表 -->
        <div
          style="
            flex: 0 0 400px;
            width: 0px;
            height: 100%;
            flex-direction: column;
            margin-left: 20px;
          "
          class="df"
        >
          <div style="text-align: left; width: 100%; margin-bottom: 20px">
            <el-radio-group v-model="radioValue" size="mini" @input="tagChange">
              <el-radio-button
                v-for="tag in tagList"
                :label="tag.label"
                :key="tag.label"
                >{{ tag.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
          <div
            style="
              flex: 1;
              height: 0;
              background-color: #f8f8f8;
              border-radius: 20px;
            "
          >
            <div style="height: 100%; width: 100%">
              <div
                style="height: 100%"
                class="df aic jcc"
                v-if="!hisListData.length"
              >
                <el-empty description="暂无记录"></el-empty>
              </div>
              <div class="modal-body" v-if="hisListData.length">
                <div
                  :class="{
                    card: true,
                    selected: hItem.id == checkedHisListId,
                  }"
                  v-for="hItem in hisListData"
                  :key="hItem.id"
                  @click="getHisDetail(hItem)"
                >
                  <div class="data-section">
                    <div class="data-item">
                      <div class="data-label">
                        {{
                          {
                            task_haccp_cam: "工序",
                            task_sw_cam: "名称",
                            task_full_cam: "商品编码",
                            task_farm_cam: "种养名称",
                          }[hisListQuery.tag]
                        }}
                      </div>
                      <div class="data-value">
                        {{
                          hItem[
                            {
                              task_haccp_cam: "templateName",
                              task_sw_cam: "question",
                              task_full_cam: "gtin",
                              task_farm_cam: "plantingName",
                            }[hisListQuery.tag]
                          ]
                        }}
                      </div>
                    </div>
                    <div class="data-item">
                      <div class="data-label">
                        {{
                          {
                            task_haccp_cam: "批次",
                            task_sw_cam: "批次",
                            task_full_cam: "批次",
                            task_farm_cam: "农事农活",
                          }[hisListQuery.tag]
                        }}
                      </div>
                      <div class="data-value">
                        {{
                          hItem[
                            {
                              task_haccp_cam: "recordName",
                              task_sw_cam: "batch",
                              task_full_cam: "batchNumber",
                              task_farm_cam: "name",
                            }[hisListQuery.tag]
                          ]
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="time-info">
                    <span class="time-label">
                      {{ hItem.startTime }}
                      <span style="color: #464547; margin: 0 10px">至</span>
                      {{ hItem.endTime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 100%; margin-top: 10px" class="df aic jcc">
            <el-pagination
              background
              @current-change="hisListChange"
              :current-page="hisListQuery.page"
              :page-size="hisListQuery.limit"
              layout="total, prev, pager, next"
              :total="hisListTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import LiveVideo from "../views/pages/DepGragh/components/LiveVideo.vue";
import axios from "../util/api";
import dayjs from "dayjs";
import api from "../util/extra-api";

export default {
  name: "VideoDialog",
  components: {
    LiveVideo,
  },
  props: {
    // 对话框是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 对话框标题
    title: {
      type: String,
      default: "",
    },
    // 公司ID
    companyId: {
      type: Number,
      required: true,
    },
    // 摄像头ID
    camId: {
      type: Number,
      default: null,
    },
    // 视频流URL
    videoUrl: {
      type: String,
      default: "",
    },
    // 新增模式控制 prop
    mode: {
      type: String,
      default: "both", // 'both': 两种模式都有, 'live-only': 只看直播, 'playback-only': 只看回看
      validator: (value) => ['both', 'live-only', 'playback-only'].includes(value)
    },
  },
  data() {
    return {
      isRealTime: this.mode === 'playback-only' ? false : true, // 根据模式初始化
      picLoading: false,
      timeValue: "",
      imageSrc: "",
      imageLoaded: false, // 新增：图片加载状态
      noImageData: false, // 新增：标记是否无图片数据
      isDialogActive: true, // 新增：标记弹窗是否活跃状态
      showNoImageMessage: false, // 新增：显示未抓取到图片的提示

      // 新增图片记录列表相关数据
      hisListDetail: [],
      checkedHisListId: null,
      hisListTotal: 0,
      radioValue: "食品加工",
      hisListData: [],
      hisListQuery: {
        page: 1,
        limit: 15,
        tag: "task_haccp_cam",
      },
      tagList: [
        {
          label: "食品加工",
          value: "task_haccp_cam",
        },
        {
          label: "日常食安",
          value: "task_sw_cam",
        },
        {
          label: "全链追溯",
          value: "task_full_cam",
        },
        {
          label: "种养生产",
          value: "task_farm_cam",
        },
      ],
      currentImageIndex: 0,
      
      // 新增AI结果相关数据
      currentAiResult: "",
      currentAiResultTime: "",
      showAiResult: false,
    };
  },
  computed: {
    // 计算是否显示切换按钮
    showToggleButton() {
      return this.mode === 'both';
    },
    // 新增计算属性：是否是第一张图片
    isFirstImage() {
      return this.checkedHisListId && this.currentImageIndex === 0;
    },
    // 新增计算属性：是否是最后一张图片
    isLastImage() {
      return this.checkedHisListId && this.currentImageIndex === this.hisListDetail.length - 1;
    }
  },
  watch: {
    // 监听 mode 变化
    mode(newMode) {
      if (newMode === 'playback-only') {
        this.isRealTime = false;
        // 如果对话框可见，加载回看数据
        if (this.visible) {
          this.initPlaybackMode();
        }
      } else if (newMode === 'live-only') {
        this.isRealTime = true;
      }
      // 'both' 模式保持当前状态不变
    },
    visible(val) {
      if (!val) {
        this.isDialogActive = false; // 标记弹窗为非活跃状态
        this.resetDialog();
      } else {
        this.isDialogActive = true; // 标记弹窗为活跃状态
        // 根据当前模式加载相应数据
        if (!this.isRealTime) {
          this.initPlaybackMode();
        }
      }
    },
  },
  methods: {
    // 初始化回看模式
    initPlaybackMode() {
      // 设置时间为当前时间
      this.timeValue = dayjs().format("YYYY-MM-DD HH:mm");
      // 加载最新截图
      this.loadImage();
      // 加载历史记录列表
      this.getHisList();
    },
    
    // 处理对话框关闭
    handleClose() {
      // 关键修改：先标记为非活跃状态，再销毁LiveVideo组件，再触发关闭事件
      this.isDialogActive = false;
      this.destroyLiveVideo();
      this.$emit("update:visible", false);
      this.$emit("close");
    },

    // 新增方法：销毁LiveVideo组件
    destroyLiveVideo() {
      const liveVideoRef = this.$refs[`live-video-${this.camId}`];
      if (liveVideoRef && liveVideoRef[0] && liveVideoRef[0].destroyPlayer) {
        liveVideoRef[0].destroyPlayer();
      }
    },
    
    // 查看直播
    handleViewLive() {
      if (this.mode === 'playback-only') return; // 只看回看模式不允许切换
      this.isRealTime = true;
    },
    
    // 重置对话框状态
    resetDialog() {
      this.imageSrc = "";
      // 重置时根据模式设置初始状态
      this.isRealTime = this.mode === 'playback-only' ? false : true;
      this.timeValue = "";
      this.picLoading = false;
      this.imageLoaded = false;
      this.noImageData = false; // 重置无图片数据状态
      this.showNoImageMessage = false; // 重置未抓取到图片提示

      // 重置图片记录列表相关状态
      this.checkedHisListId = null;
      this.hisListData = [];
      this.hisListDetail = [];
      this.currentImageIndex = 0;
      this.hisListQuery.page = 1;
      
      // 重置AI结果相关状态
      this.currentAiResult = "";
      this.currentAiResultTime = "";
      this.showAiResult = false;
    },

    // 留影回看
    handleReplyPics() {
      if (this.mode === 'live-only') return; // 只看直播模式不允许切换
      this.isRealTime = false;
      this.initPlaybackMode();
    },

    // 时间变化处理
    handleTimeChange(time) {
      this.loadImage();
      // 时间切换模式下不显示AI结果
      this.showAiResult = false;
    },

    // 图片加载成功处理
    handleImageLoad() {
      if (!this.isDialogActive) return; // 弹窗关闭时不处理
      this.picLoading = false;
      this.imageLoaded = true;
      this.showNoImageMessage = false;
    },
    
    // 图片加载失败处理
    handleImageError() {
      if (!this.isDialogActive) return; // 弹窗关闭时不处理
      
      // 如果是无图片数据状态，不显示错误消息
      if (this.noImageData) {
        this.picLoading = false;
        this.imageLoaded = false;
        return;
      }
      
      this.picLoading = false;
      this.imageLoaded = false;
      this.showNoImageMessage = false;
      
      // 只有在弹窗活跃状态下才显示错误消息
      if (this.isDialogActive) {
        this.$message.error('图片加载失败');
      }
    },

    // 上一张图片
    handlePre() {
      if (this.checkedHisListId) {
        // 在图片记录详情中切换
        this.currentImageIndex = Math.max(0, this.currentImageIndex - 1);
        this.loadImageByIndex(this.currentImageIndex);
      } else {
        // 原有时间切换逻辑
        this.timeValue = dayjs(this.timeValue)
          .subtract(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.loadImage();
        // 时间切换模式下不显示AI结果
        this.showAiResult = false;
      }
    },

    // 下一张图片
    handleNext() {
      if (this.checkedHisListId) {
        // 在图片记录详情中切换
        this.currentImageIndex = Math.min(
          this.hisListDetail.length - 1,
          this.currentImageIndex + 1
        );
        this.loadImageByIndex(this.currentImageIndex);
      } else {
        // 原有时间切换逻辑
        this.timeValue = dayjs(this.timeValue)
          .add(1, "minute")
          .format("YYYY-MM-DD HH:mm");
        this.loadImage();
        // 时间切换模式下不显示AI结果
        this.showAiResult = false;
      }
    },
    
    // 新增方法：根据索引加载图片
    loadImageByIndex(index) {
      if (!this.hisListDetail[index]) return;
      
      const imageItem = this.hisListDetail[index];
      
      // 检查imgUrl是否为"未抓取到摄像图片"
      if (imageItem.imgUrl === "未抓取到摄像图片") {
        this.showNoImageMessage = true;
        this.picLoading = false;
        this.imageLoaded = false;
        this.imageSrc = "";
        this.updateAiResultDisplay(index);
        return;
      }
      
      this.showNoImageMessage = false;
      this.picLoading = true;
      this.imageLoaded = false;
      this.imageSrc = imageItem.imgUrl;
      this.updateAiResultDisplay(index);
    },

    // 加载图片
    loadImage() {
      if (!this.camId || !this.timeValue) {
        this.picLoading = false;
        return;
      }

      this.picLoading = true;
      this.imageLoaded = false;
      this.noImageData = false; // 重置无图片数据状态
      this.showNoImageMessage = false;
      
      axios
        .get("/pc/company-cam/camImg", {
          camId: this.camId,
          time: this.timeValue,
        })
        .then((response) => {
          if (!this.isDialogActive) return; // 弹窗关闭时不处理
          
          // 检查返回的数据是否为"未抓取到摄像图片"
          if (response.data === "未抓取到摄像图片") {
            this.showNoImageMessage = true;
            this.imageSrc = "";
            this.picLoading = false;
            return;
          }
          
          this.showNoImageMessage = false;
          this.imageSrc = response.data;
          // 不在这里关闭loading，等待图片实际加载完成
        })
        .catch((error) => {
          if (!this.isDialogActive) return; // 弹窗关闭时不处理
          
          console.error("加载图片失败:", error);
          this.picLoading = false;
          this.showNoImageMessage = false;
          
          // 只有在弹窗活跃状态下才显示错误消息
          if (this.isDialogActive) {
            this.$message.error("加载图片失败");
          }
        });
    },

    // 修改方法：获取图片记录详情 - 直接使用列表项的 info 数据
    getHisDetail(data) {
      this.checkedHisListId = data.id;
      this.currentImageIndex = 0;
      this.picLoading = true;
      this.imageLoaded = false;
      this.noImageData = false; // 重置无图片数据状态
      this.showNoImageMessage = false;
      console.log("获取图片记录详情:", data);
      
      // 直接使用列表项中的 info 数组数据
      if (data.info && Array.isArray(data.info) && data.info.length > 0) {
        this.hisListDetail = data.info;
        
        // 检查第一张图片的imgUrl是否为"未抓取到摄像图片"
        const firstImage = this.hisListDetail[0];
        if (firstImage.imgUrl === "未抓取到摄像图片") {
          this.showNoImageMessage = true;
          this.imageSrc = "";
          this.picLoading = false;
        } else {
          this.showNoImageMessage = false;
          this.imageSrc = firstImage.imgUrl;
        }
        
        // 显示第一张图片的AI结果
        this.updateAiResultDisplay(0);
      } else {
        this.noImageData = true; // 标记为无图片数据状态
        this.showNoImageMessage = true;
        this.hisListDetail = [];
        this.imageSrc = "";
        this.showAiResult = false;
        this.picLoading = false;
        
        // 只有在弹窗活跃状态下才显示警告消息
        if (this.isDialogActive) {
          this.$message.warning("该记录暂无图片数据");
        }
      }
    },

    // 新增方法：更新AI结果显示
    updateAiResultDisplay(index) {
      if (this.hisListDetail[index]) {
        const currentItem = this.hisListDetail[index];
        this.currentAiResult = currentItem.aiResult || "暂无AI识别结果";
        this.currentAiResultTime = currentItem.time || "";
        this.showAiResult = true;
      } else {
        this.currentAiResult = "";
        this.currentAiResultTime = "";
        this.showAiResult = false;
      }
    },

    // 新增方法：格式化AI结果（将换行符转换为HTML换行）
    formatAiResult(aiResult) {
      if (!aiResult) return "暂无AI识别结果";
      // 将文本中的换行符转换为HTML换行标签
      return aiResult.replace(/\n/g, '<br>').replace(/<br>/g, '<br>');
    },

    // 新增方法：返回列表
    handleReturnToList() {
      this.checkedHisListId = null;
      this.hisListDetail = [];
      this.currentImageIndex = 0;
      this.noImageData = false; // 重置无图片数据状态
      this.showNoImageMessage = false;
      this.timeValue = dayjs().format("YYYY-MM-DD HH:mm");
      this.loadImage();
      // 隐藏AI结果
      this.showAiResult = false;
    },

    // 新增方法：标签切换
    tagChange(value) {
      this.hisListData = [];
      this.hisListQuery.tag = this.tagList.filter(
        (v) => v.label === value
      )[0].value;
      this.hisListQuery.page = 1;
      this.getHisList();
    },

    // 新增方法：列表分页
    hisListChange(page) {
      this.hisListQuery.page = page;
      this.getHisList();
    },

    // 获取图片记录列表
    getHisList() {
      // 这里需要根据实际API调整
      api
        .get("/v1/wx/monitor/camHistoryList", {
          camId: this.camId,
          ...this.hisListQuery,
        })
        .then((response) => {
          if (!this.isDialogActive) return; // 弹窗关闭时不处理
          
          if (response.code === 200) {
            this.hisListData = response.data;
            this.hisListTotal = response.total;
          }
        })
        .catch((error) => {
          if (!this.isDialogActive) return; // 弹窗关闭时不处理
          console.error("获取图片记录列表失败:", error);
        });
    },
  },
};
</script>

<style scoped>
.blue {
  color: #409eff;
}

/* 新增样式，复制自参考组件 */
.df {
  display: flex;
}

.aic {
  align-items: center;
}

.jcc {
  justify-content: center;
}

.modal-body {
  padding: 10px;
  overflow-y: auto;
  height: 100%;
  overflow-x: hidden;
}

.card {
  width: 100%;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  padding: 16px;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid #eaeaea;
  margin-bottom: 5px;
}

.card:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
  border-color: #d0d7de;
}

.data-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.data-item {
  flex: 1;
}

.data-label {
  font-size: 12px;
  color: #777;
  margin-bottom: 4px;
  font-weight: 500;
}

.data-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  line-height: 1.4;
  word-break: break-word;
}

.time-info {
  background-color: #f0f7ff;
  border-radius: 4px;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  border-left: 3px solid #4a90e2;
}

.time-label {
  color: #4a90e2;
}

.card.selected {
  border: 2px solid #4a90e2;
  background-color: #f0f7ff;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.2);
  transform: translateY(-1px);
}

.card.selected .time-info {
  background-color: #fff;
}

.modal-body::-webkit-scrollbar {
  width: 10px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f0f7ff;
  border-radius: 5px;
  border-left: 1px solid #e1e8f0;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #4a90e2;
  border-radius: 5px;
  border: 2px solid #f0f7ff;
  box-shadow: 0 2px 4px rgba(74, 144, 226, 0.2);
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #357abd;
  box-shadow: 0 4px 8px rgba(74, 144, 226, 0.3);
}

/* 新增AI结果样式 */
.ai-result-container {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  background-color: #f8f9fa;
}

.ai-result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
}

.ai-result-content {
  font-size: 13px;
  line-height: 1.5;
  color: #606266;
  white-space: pre-wrap;
}

/* 新增禁用按钮样式 */
.el-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 图片计数样式 */
.image-counter {
  font-size: 14px;
  color: #606266;
  line-height: 32px;
  text-align: center;
}

/* 图片加载占位符样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
  flex-direction: column;
}

/* 未抓取到图片的特殊样式 */
.image-slot.no-image-message {
  height: 200px;
  background: #f5f7fa;
  color: #909399;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}

.image-slot .dot {
  animation: dot 1.5s steps(3, end) infinite;
}

@keyframes dot {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);
  }
  40% {
    color: #909399;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);
  }
  60% {
    text-shadow:
      .25em 0 0 #909399,
      .5em 0 0 rgba(0,0,0,0);
  }
  80%, 100% {
    text-shadow:
      .25em 0 0 #909399,
      .5em 0 0 #909399;
  }
}
</style>